// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  jobId: __t.u64().primaryKey().name("job_id"),
  quoteId: __t.u64().name("quote_id"),
  requestId: __t.string().name("request_id"),
  owner: __t.identity(),
  stationKey: __t.string().name("station_key"),
  role: __t.string(),
  kind: __t.string(),
  version: __t.u32(),
  shipId: __t.u64().name("ship_id"),
  fitRev: __t.string().name("fit_rev"),
  wreckId: __t.u64().name("wreck_id"),
  restoreHp: __t.u32().name("restore_hp"),
  missiles: __t.u32(),
  counters: __t.u32(),
  parts: __t.u32(),
  source: __t.string(),
  supplier: __t.identity(),
  engineer: __t.identity(),
  operator: __t.identity(),
  partsSov: __t.i64().name("parts_sov"),
  labourSov: __t.i64().name("labour_sov"),
  rearmSov: __t.i64().name("rearm_sov"),
  operatorFeeSov: __t.i64().name("operator_fee_sov"),
  platformFeeSov: __t.i64().name("platform_fee_sov"),
  totalSov: __t.i64().name("total_sov"),
  state: __t.string(),
  acceptedAt: __t.timestamp().name("accepted_at"),
  readyAt: __t.timestamp().name("ready_at"),
  endedAt: __t.timestamp().name("ended_at"),
  receiptJson: __t.string().name("receipt_json"),
  note: __t.string(),
});
